import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, change, reset } from "redux-form";
import { required, validatePhone, formatPhone } from "../utility";
import { MaterialTextField, MaterialMaskedTextField, MaterialCheckbox } from "./MaterialInput";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SubmitButton from './SubmitButton';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import * as agent from "../agent";
import { smsTemplates, Masks } from "../constants/enums";

const smsForm = ({ clientId, changeFieldValue, onSendSMS, handleSubmit }) => (
    <Paper className="common-paper">
        <Grid container spacing={16}>
            <Grid item className="common-form wide-column">
                <form onSubmit={handleSubmit(data => onSendSMS(clientId, data))} >
                    <Typography variant="h5" align="center">Отправить СМС</Typography>
                    <Field component={MaterialTextField}
                           disabled={true}
                           name="client"
                           label="Клиент" />
                    <Field component={MaterialMaskedTextField}
                           disabled={true}
                           mask={Masks.phone}
                           format={formatPhone}
                           validate={validatePhone}
                           placeholder="+7 (___) ___-__-__"
                           name="phone"
                           label="Телефон" />
                    <Tooltip title={`Сообщения с подписью стоят дороже обычных`}>
                        <FormControlLabel
                             control={
                                 <Field name="useSign"
                                        component={MaterialCheckbox} />
                             }
                             label="С подписью"/>
                    </Tooltip>
                    <Field component={MaterialTextField}
                           validate={required}
                           rows={10}
                           multiline
                           name="text"
                           label="Текст сообщения" />
                    <SubmitButton label="Отправить СМС" />
                </form>
            </Grid>
            <Grid item className="common-form common-column">
                <Typography variant="h5" align="center">Шаблоны</Typography>
                <Tooltip title={`Данный шаблон будет разбит на несколько отдельных СМС`}>
                    <Button onClick={e => {
                                e.preventDefault();
                                changeFieldValue("text", smsTemplates["natural_person"])}
                            }
                            size="large"
                            fullWidth
                            color="secondary"
                            variant="contained"> Документы физ. лица </Button>
                </Tooltip>
                <Tooltip title={`Данный шаблон будет разбит на несколько отдельных СМС`}>
                    <Button onClick={e => {
                                e.preventDefault();
                                changeFieldValue("text", smsTemplates["juridical_person"])}
                            }
                            size="large"
                            fullWidth
                            color="secondary"
                            variant="contained"> Документы юр. лица </Button>
                </Tooltip>
                <Button onClick={e => {
                            e.preventDefault();
                            changeFieldValue("text", smsTemplates["requisites"])}
                        }
                        size="large"
                        fullWidth
                        color="secondary"
                        variant="contained"> Реквизиты </Button>
            </Grid>
        </Grid>
    </Paper>
);

const SmsForm = connect(
    (state, props) => {
        const { phone, client } = props;
        return {
            initialValues: {
                phone,
                client
            }
        }
    },
    dispatch => ({
        onSendSMS: (id, details) =>
            agent.Clients.sendSMS(id, details)
                .then(() => dispatch(reset("sms-form")))
                .then(() => alert("Сообщение успешно отправлено"))
                .catch(e => alert(e.message)),
        changeFieldValue: (field, value) =>
            dispatch(change("sms-form", field, value))
    })
)(reduxForm({
    form: "sms-form",
})(smsForm));

export default SmsForm;



// WEBPACK FOOTER //
// ./src/components/SmsForm.js